// constants
import { showSuccessAlert } from "../../constants/alerts";
import { TestimonialActionTypes } from "./constants";

const INIT_STATE = {
  testimonial: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface testimonialData {
  id: number;
  rating: string;
  comment_en: string;
  comment_ar: string;
  user_name: string;
  user_role: string;
}

interface TestimonialActionType {
  type:
    | TestimonialActionTypes.API_RESPONSE_SUCCESS
    | TestimonialActionTypes.API_RESPONSE_ERROR
    | TestimonialActionTypes.CREATE_TESTIMONIAL
    | TestimonialActionTypes.UPDATE_TESTIMONIAL
    | TestimonialActionTypes.GET_TESTIMONIAL
    | TestimonialActionTypes.DELETE_TESTIMONIAL;
  payload: {
    actionType?: string;
    data?: testimonialData | {};
    error?: string;
    testimonial?: [];
  };
}

interface State {
  testimonial?: testimonialData[] | [];
  loading?: boolean;
  value?: boolean;
}

const TestimonialStates = (state: State = INIT_STATE, action: TestimonialActionType): any => {
  switch (action.type) {
    case TestimonialActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case TestimonialActionTypes.CREATE_TESTIMONIAL: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case TestimonialActionTypes.GET_TESTIMONIAL: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            testimonial: action.payload.data,
          };
        }
        case TestimonialActionTypes.UPDATE_TESTIMONIAL: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case TestimonialActionTypes.DELETE_TESTIMONIAL: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case TestimonialActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case TestimonialActionTypes.CREATE_TESTIMONIAL: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case TestimonialActionTypes.UPDATE_TESTIMONIAL: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case TestimonialActionTypes.GET_TESTIMONIAL: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case TestimonialActionTypes.DELETE_TESTIMONIAL: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case TestimonialActionTypes.CREATE_TESTIMONIAL:
      return { ...state, loading: true };
    case TestimonialActionTypes.UPDATE_TESTIMONIAL:
      return { ...state, loading: true };
    case TestimonialActionTypes.GET_TESTIMONIAL:
      return { ...state, loading: true, initialLoading: true };
    case TestimonialActionTypes.DELETE_TESTIMONIAL:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default TestimonialStates;
